<!--
 * @Descripttion:
 * @version:
 * @Author: ouli
 * @Date: 2021-05-26 16:37:54
 * @LastEditors: ouli
 * @LastEditTime: 2021-11-09 15:39:35
-->
<template>
  <div class="box-shadow">
    <div class="custom-menu beauty-scroll">
      <div class="org-select-container">
        <header-select class="header-item" />
      </div>
      <i-menu
        :theme="theme"
        :collapsed="collapsed"
        :options="menuData"
        @select="onSelect"
        class="menu"
      >
        <span slot="icon" slot-scope="{icon}">
          <RenderIcon :vNode="icon" />
        </span>
      </i-menu>
    </div>
    <div class="menu-trigger" @click="toggleCollapse" title="展开/收起">
      <ls-icon
        class="trigger"
        :type="collapsed ? 'menu-unfold' : 'menu-fold'"
      />
    </div>
  </div>
</template>

<script>
import IMenu from "./menu";
import HeaderSelect from '@/components/GlobalHeader/HeaderSelect'

const RenderIcon = {
  props: {
    vNode: [Array, String, Object, Number]
  },
  render (h) {
    if (typeof this.vNode === 'object') {
      return this.vNode
    } else {
      return h('lsIcon', { props: { type: this.vNode, size: 16 } })
    }
  }
}

export default {
  name: "SideMenu",
  components: { IMenu, RenderIcon, HeaderSelect },
  props: {
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menuData: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: "dark"
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scmUrl: process.env.VUE_APP_API_SCM_URL,
      plmUrl: process.env.VUE_APP_API_PLM_URL,
      iconSize: 16
    }
  },
  computed: {
    sideTheme () {
      return this.theme === "light" ? this.theme : "dark";
    }
  },
  mounted () {
  },
  methods: {
    toggleCollapse () {
      this.$emit("toggleCollapse");
    },
    onSelect (obj) {
      this.$emit("menuSelect", obj);
    }
  }
};
</script>

<style lang="less" scoped>
@import "index";
/deep/ .ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left{
  border: 1px solid transparent;
}
.system-name{
  /deep/ .ant-dropdown-link .logo-text{
    padding-top: 3px;
  }
}
.box-shadow{
  box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);
}
.menu-trigger{
  text-align: center;
  cursor: pointer;
  height: 38px;
  border-top: 1px solid #f0f0f0;
  .anticon-menu-fold, .anticon-menu-unfold{
    font-size: 20px;
    line-height: 38px;
    padding: 0;
  }
}
.menu-trigger:hover{
  background: #e6f7ff;
}
.ant-menu-item .anticon, .ant-menu-submenu-title .anticon{
  font-size: 13px;
  i{
    margin-right: 0;
  }
}
/deep/.ant-menu-vertical .ant-menu-item,
/deep/.ant-menu-vertical-left .ant-menu-item,
/deep/.ant-menu-vertical-right .ant-menu-item,
/deep/.ant-menu-inline .ant-menu-item,
/deep/.ant-menu-vertical .ant-menu-submenu-title,
/deep/.ant-menu-vertical-left .ant-menu-submenu-title,
/deep/.ant-menu-vertical-right .ant-menu-submenu-title,
/deep/.ant-menu-inline .ant-menu-submenu-title{
 font-size: 13px;
}
/deep/.ant-menu-inline-collapsed > .ant-menu-item,
/deep/.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
/deep/.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title,
/deep/.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title{
  padding: 0 30px !important;
}
/deep/.ant-menu-sub .ant-menu-inline .ant-menu-item{
  padding-left:58px!important;
}
.ant-pro-sider-menu-sider.fix-sider-bar .ant-menu-root{
  height: calc(100vh - 140px);
}
.org-select-container {
  width: 100%;
  padding: 8px 0;
  display: flex;
  justify-content: center;
}
</style>
